import { IconProps } from "../Icon";
import { MenuItemProps } from "./MenuItems";

export type ContextMenuProps = {
  menuItems: MenuItemProps[];
  trigger?: React.ReactNode;
  triggerClassName?: string;
  triggerIconProps?: IconProps;
  triggerTestId?: string;
  contentTestId?: string;
  contentClassName?: string;
  leadChildren?: React.ReactNode;
  tailChildren?: React.ReactNode;
  side?: ContextMenuSideAlignment;
  sideOffset?: number;
  align?: ContextMenuAlignAlignment;
  alignOffset?: number;
  disabled?: boolean;
  onOpenChange?: (open: boolean) => boolean | void;
  noBorder?: boolean;
};

export type ContextMenuContentProps = Omit<ContextMenuProps, "leadChildren" | "tailChildren">;

export enum ContextMenuSideAlignment {
  RIGHT = "right",
  LEFT = "left",
  BOTTOM = "bottom",
  TOP = "top",
}

export enum ContextMenuAlignAlignment {
  CENTER = "center",
  START = "start",
  END = "end",
}
